<template>
	<div class="order">
		<div class="vx-row">
			<div class="vx-col w-full ">
				<vx-card class="align-center">
					<div class="vx-row order__head">
						<div class="d-flex align-center vx-col order__head-col">
							<div class="vx-row order__head-col_inner">
								<div class="order__head-order vx-col order__head-col">
									<b>{{ $t('order') }} №</b><span class="status">{{ order.id }}</span>
								</div>
								<div class="order__head-status vx-col order__head-col" >
									<b>{{ $t('currentOrderStatus') }}</b>
									<span class="status" :class="$getStatusColor(order.status)">{{ $getStatus(order.status) }}</span>
								</div>

								<div
									v-if="!!order.manager"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('manager') }}
										</div>
										<div class="order-author__block">
											<div class="order-author__photo">
												<img v-if="order.manager.photo" :src="order.manager.photo"/>
											</div>
											<div class="order-author__name">
												{{ order.manager.username }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="buttons vx-col vx-row order__head-col order__controls">
							<div class="vx-col order__control order__head-col">
								<vs-button @click="openChat">{{ $t('writeMessage') }}</vs-button>
							</div>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 w-full mt-8">
				<CardOrderView
					:model="order"
					:subjects="subjects"
					:works="works"
					:levels="levels"
					:languages="languages"
				/>
			</div>
			<div class="vx-col lg:w-1/2 w-full mt-8">
				<CardStages
					v-if="$store.state.auth.role !== 'author'"
					:orderId="order.id"
					:stages="stages"
					:status="order.status"
					:works="[]"
					@updateModel="updateModel"
					@updateStages="updateStages"
					@openTerminatePopup="popupActive = true"
				/>
			</div>
		</div>
		<vs-popup class="holamundo close-order" :title="$t('confirmAction')" :active.sync="popupActive">
			<p>{{ $t('youWantToCompleteOrder') }} <b>№{{ order.id }}.</b> <br>{{ $t('thisActionIsIrreversible') }}</p>
			<div class="vs-popup--button">
				<vs-button @click="closeOrder" color="warning">
					{{ $t('completeOrder') }}
				</vs-button>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import CardOrderView from "@/views/Orders/CardOrderView";
import CardStages from "@/views/Orders/CardStages";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "Order",
	mixins: [databaseManager, notifier],
	components: {
		CardOrderView,
		CardStages
	},
	data() {
		return {
			popupActive: false,
			order: {},
			stages: [],
			levels: [],
			languages: [],
			works: [],
			subjects: [],
		}
	},
	computed:{
		totalPrice: function () {
			if (!this.stages) return ''
			return this.stages.reduce((acc, item) => acc + item.price_client,0);
		},
	},
	methods:{
		async updateModel() {
			const id = this.$route.params.id;
			this.order = await this.dbViewOrder(id);
		},
		async updateStages() {
			this.stages = await this.dbViewStages(this.$route.params.id);
		},
		async openChat(){
			await this.$store.dispatch('getMessages',{id: this.$route.params.id})
		},
		async closeOrder(){
			try {
				const role = this.$store.state.auth.role;
				await this.$http.post(`/${role}/order/complete/${this.$route.params.id}`);

				await this.updateModel();
				await this.updateStages();

				this.popupActive=false;
				this.notifySuccess(this.$t('orderIsCompletedSuccessfully'));
			}catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	async mounted () {
		const role = this.$store.state.auth.role;
		const orderId = this.$route.params.id;

		if(role !== "client") return await this.$router.push(`/ticket/${orderId}`);

		this.levels = (await this.$http.get('/settings/get-quality-levels')).data.data;
		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.works = (await this.$http.get('/settings/get-work-types')).data.data;
		this.subjects = (await this.$http.get('/settings/get-subjects')).data.data;

		this.order = (await this.$http.get(`/${role}/order/view/${orderId}`)).data.data;
		this.stages = (await this.$http.get(`/${role}/order/get-milestones/${orderId}`)).data.data;
	},
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/functions";
@import "./src/assets/scss/vuexy/variables";

.align-center {
	align-items: center;
}

.flex-wrap {
	flex-wrap: wrap;
	@media (max-width: 768px) {
		div {
			padding: 0.5rem 0;
		}

	}
}

.justify-between {
	justify-content: space-between;
}

.d-flex {
	display: flex;
}

.order {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.6rem;
		width: 2.6rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 21px;
		align-items: center;
		border-color: #e4e4e4 !important;
		border-left: 0 !important;
		background-color: #f7f6f6 !important;

	}

	.vs-con-input-label {
		width: 220px;
	}

	&__controls {
		.order__control {
			.vs-button {
				width: 100%;
				padding: 8px 15px !important
			}
		}

		@media screen and (max-width: 576px) {
			flex-direction: column;
			max-width: 470px;
		}
	}

	&-author {
		display: flex;
		//padding: 0 !important;

		&__container {
			display: flex;
		}

		&__title {
			display: flex;
			align-items: center;
			font-size: 18px;
			font-weight: 600;
		}

		&__block {
			position: relative;
			display: flex;
			align-items: center;
			border-radius: 1000px;
			background-color: #F8F8F8;
			height: 35px;
			border: rgba(136, 136, 136, 0.5) 1px solid;
			padding: 0 25px 0 0 !important;
			margin-left: 10px;
		}

		&__photo {
			position: absolute;
			left: -1px;
			border-radius: 100%;
			width: 35px;
			height: 35px;
			overflow: hidden;
			background-color: $primary;

			img {
				width: 100%;
				height: 100%;
				border-radius: 100%;
			}
		}

		&__name {
			margin-left: 45px;
			color: #3D3D3D;
			font-weight: 600;
			white-space: nowrap;
		}
	}

	.stages {

		.stage {
			border-bottom: 1px solid #e4e4e4;
			padding: 15px 0;

			.head {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				align-items: center;
			}

			.body {
				justify-content: space-between;
				flex-wrap: wrap;
				align-items: center;
			}
		}
	}

	&__details {
		td {
			padding-bottom: 5px;
			vertical-align: top;
			&:first-child {
				width: 300px;
			}
		}
	}

	.vx-card__body {
		padding: 1rem 1.5rem !important;
	}

	&__head {
		@media screen and (max-width: 580px){
			justify-content: center !important;
		}
	}

	&__head-col {
		@media screen and (max-width: 768px) {
			justify-content: center;
			flex: 100%;

			&_inner {
				justify-content: center;
				flex: 100%;
				margin-top: -10px;

				& > .vx-col {
					margin-top: 10px;
				}
			}
		}
	}

	&__head {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: -8px;
		margin-bottom: -8px;

		@media (max-width: 768px) {
			margin-top: -4px;
			margin-bottom: -4px;

			&-col {
				margin-top: 0px;
				margin-bottom: 4px;
			}

			button {
				margin-top: 12px;
			}
		}

		b {
			margin-right: 10px;
		}

		&-status,
		&-order {
			align-items: center;
			display: flex;
		}

		&-info {
			display: flex;
			align-items: center;
		}

		&-col {
			margin-top: 8px;
			margin-bottom: 8px;
		}
	}

	.manager {
		display: flex;
		align-items: center;
		background-color: #f8f8f8;
		border-radius: 20px;

		strong {
			padding: 0 10px;
		}
	}

	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;

		&-ok {
			background-color: $success;
		}

		&-warn {
			background-color: $warning;
		}

	}
}

.holamundo.close-order {
	.vs-popup {
		max-width: 400px !important;

		&--content {
			padding: 0 !important;
		}

		&--title {
			h3 {
				color: $warning;
			}
		}

		&--close {
			color: $warning;
		}

		p {
			padding: 1rem;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			border-top: 1px solid #e4e4e4;
			padding: 1rem;
			padding-bottom: 0.5rem;

		}
	}
}
</style>
